import { InformationCircleIcon } from "@heroicons/react/outline";
import { ArtButton } from "components/button";
import { TextInput } from "components/input/text-input";
import { useState } from "react";
import {
    Modal,
} from "semantic-ui-react";
import { api, ui } from "services";

export default function TwoFactorAuthenticator({ open, onClose, onSuccess }: any) {
    const [isContinue, setIsContinue] = useState(false);
    const [textInput, setTextInput] = useState("");

    const resetState = () => {
        setIsContinue(false);
        setTextInput("");
    }

    const onSubmit = () => {
        api.confirmSetup2FA(textInput, open?.secret ?? "motconvit").then(data => {
            ui.alertSuccess("Enable second authentication successful !", "");
            onSuccess();
            onClose();
            resetState();
        }).catch(err => {
            ui.alertFailed("Enable second authentication factor failed !", "Your OTP code is not valid ! Please try again later !");
            onClose();
            resetState();
        })
    }

    return (
        <Modal
            size="small"
            open={!!open}
            style={{ width: "unset" }}
        >
            <div
                className="w-[600px]"
            >
                <div className="w-[600px] bg-black-secondary pb-8">
                    {!isContinue && <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            Second Authentication Factor
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

                        <div className="w-11/12 mx-auto text-white text-center">
                            <div className="col-span-1">
                                <div className="mb-4">
                                    Scan the QR code using your phone's camera
                                </div>
                                {open && <img className="text-center mx-auto" src={open.qrImage} width={300} height={300} alt="qr_code" />}
                            </div>
                            <div className="text-white text-lg col-span-1 mt-4 self-center">
                                <div>
                                    Secret key: {open?.secret}
                                </div>
                            </div>
                            <div className="text-left mt-2 text-sm">
                                <InformationCircleIcon className="h-6 w-6 inline-block mr-1" />
                                Make sure to save the QR code and secret key, because they are required to access the second authentication factor, for example,
                                if you lose your phone or need to install the mobile authenticator on other devices.
                                <div className="mt-2">
                                    <InformationCircleIcon className="h-6 w-6 inline-block mr-1" />
                                    Do not show or give out your QR code or secret key to anyone.
                                </div>
                            </div>
                        </div>

                        <div className={`flex w-[360px] gap-4 mt-10 text-center items-center mx-auto`}>
                            <ArtButton color="yellow"
                                className="py-4"
                                onClick={() => setIsContinue(true)}
                            >
                                <div className="mt-1 text-lg text-white font-semibold">
                                    Continue
                                </div>
                            </ArtButton>
                        </div>
                    </div>}
                    {isContinue && <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            Second Authentication Factor
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />
                        <div className="w-11/12 mx-auto">
                            <div className="mb-6 text-white">
                                To finish enabling the second authentication factor, enter the one-time password which you have obtained using the mobile authenticator in the previous step.
                            </div>
                            <div className="text-center text-white flex mx-auto justify-center w-full overflow-hidden rounded-lg relative">
                                <TextInput
                                    value={textInput}
                                    setValue={setTextInput}
                                    className="text-md block w-full h-[54px] text-black font-medium"
                                    fieldName=""
                                    placeholder={'Enter verification code'}
                                />
                            </div>
                        </div>
                        <div className={`flex w-[200px] gap-4 mt-10 text-center items-center mx-auto`}>
                            <ArtButton color="yellow"
                                className="py-4"
                                onClick={() => onSubmit()}
                            >
                                <div className="text-white font-semibold">
                                    Active
                                </div>
                            </ArtButton>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </Modal>
    );
}
